import { AbstractVisibilityMonitor } from './abstract-visibility-monitor';
import { VisibilityMonitorEvents } from './enums';
import { VisibilityMonitorState } from './models';

export class VisibilityMonitorIntersectionObserver extends AbstractVisibilityMonitor {

    private _visible: boolean;
    private observer: IntersectionObserver;
    private _state: VisibilityMonitorState = {
        element: null,
        isIntersecting: false,
        documentVisible: !document.hidden,
    };

    get state(): VisibilityMonitorState {
        return this._state;
    }

    get visible(): boolean {
        return this._visible;
    }

    set state(value: VisibilityMonitorState) {
        this._state = {...this._state, ...value};
        this.visible = this._state.documentVisible && this._state.isIntersecting;
    }

    set visible(value: boolean) {
        if (value !== this._visible) {
            this._visible = value;
            const event: VisibilityMonitorState = {...this._state, visible: this._visible};
            this.emit(VisibilityMonitorEvents.VisibilityChange, event);
        }
    }

    constructor(private element: HTMLElement) {
        super();
        this.on(VisibilityMonitorEvents.VisibilityChange, (e: VisibilityMonitorState) => {
            if (this.visible) {
                this.emit(VisibilityMonitorEvents.Visible, {...e});
            } else {
                this.emit(VisibilityMonitorEvents.Hidden, {...e});
            }
        });
        this.state = {element: element, documentVisible: !document.hidden};
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            threshold: [0.75],
        });
        document.addEventListener('visibilitychange', () => {
            this.state = {documentVisible: !document.hidden};
        });
    }

    onIntersect(entries: IntersectionObserverEntry[], observer: IntersectionObserver): void {
        const intersection: IntersectionObserverEntry = entries[entries.length - 1];
        this.state = {
            element: intersection.target as HTMLElement,
            documentVisible: !document.hidden,
            isIntersecting: intersection.isIntersecting,
        };
    }

    start(): void {
        this.observer.observe(this.element);
    }

    stop(): void {
        this.observer.unobserve(this.element);
    }

    observe(element: HTMLElement): void {
        this.stop();
        this.element = element;
        this.start();
    }

}
